var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center"},[_c('EMoveIntroduction'),_c('EMoveFunction'),_c('EMoveValue'),_c('EMoveScenarios'),_c('EMovePrice')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }